import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledFakeBlurOverlay = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    backdrop-filter: blur(8px);\n    z-index: 1;\n  }\n\n  > * {\n    position: relative;\n    filter: blur(4px);\n    pointer-events: none;\n    user-select: none;\n  }\n"])));
export var FakeBlurOverlay = function FakeBlurOverlay(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(StyledFakeBlurOverlay, {
    children: children
  });
};